import { ISecurity, IValue, IState, IUserPosition, IMDT, IProject } from "../models";

export const StorageItems = {
	FACILITIES: "facilities",
	TITLES: "titles",
	STATES: "states",
	POSITIONS: "positions",
	CONTACTDETAILS: "ContactDetails",
	QOOLUSERASSOCIATEDDATA: "qoolUserAssociatedData",
	API_RETRIES: "retries",
	AJAX_MONITOR_LAST_PUSH_UP_TIME: "ajaxMonitorLastPushUpTime",
};

export const  acceptTermsKey : string = "lastAcceptanceDate";  

export const MaxApiRetries: number = 3;
export const USER = "user";
export const USERACCOUNTDETAILS = "userAccountDetails";

export class QCCATSessionStorage {
	private static getValue(key: string, refresh: boolean = false, onNotFound: any = null) {
		let stored = sessionStorage.getItem(key);
		if (stored) {
			try {
				return JSON.parse(stored);
			} catch (error) {
				console.log(error);
			}
		}

		return onNotFound;
	}
	private static setValue<T>(key: string, value: any): T {
		sessionStorage.setItem(key, JSON.stringify(value));
		return value;
	}
	private static removeValue<T>(key: string) {
		sessionStorage.removeItem(key);
	}

	public static resetExistingStorageValues = () => {
		for (let prop in StorageItems) {
			if (StorageItems.hasOwnProperty(prop)) {
				sessionStorage.removeItem(StorageItems[prop]);
			}
		}
	}

	// Note that sessionStorage is limited in space. We may need to extend if caching is considerable.

	public static getUser = (refresh: boolean = false, onNotFound: Promise<any> = null) => QCCATSessionStorage.getValue(USER, refresh) as ISecurity;
	public static setUser = (user: ISecurity) => QCCATSessionStorage.setValue(USER, user);

	public static removeUser = () => {
		QCCATSessionStorage.removeValue(USER);
		QCCATSessionStorage.removeValue(USERACCOUNTDETAILS);
	}

	public static resetApiRetries = () => QCCATSessionStorage.setValue(StorageItems.API_RETRIES, 0);
	public static incrementApiRetries = () => {
		let retries = QCCATSessionStorage.getValue(StorageItems.API_RETRIES, false, 0) as number;
		QCCATSessionStorage.setValue(StorageItems.API_RETRIES, retries + 1);
	}
	public static reachedMaxApiRetries = (): boolean => (QCCATSessionStorage.getValue(StorageItems.API_RETRIES, false, 0) as number) >= MaxApiRetries;

	public static getUserAccountDetails = (refresh: boolean = false) => QCCATSessionStorage.getValue(USERACCOUNTDETAILS, refresh);
	public static setUserAccountDetails = (userAccountDetails) => QCCATSessionStorage.setValue(USERACCOUNTDETAILS, userAccountDetails);

	public static getFacilities = (refresh: boolean = false) => QCCATSessionStorage.getValue(StorageItems.FACILITIES, refresh) as IValue[];
	public static setFacilities = (facilities: IValue[]) => QCCATSessionStorage.setValue(StorageItems.FACILITIES, facilities);

	public static getFacilitiesByStateId = (stateId: string, refresh: boolean = false) => QCCATSessionStorage.getValue(`${StorageItems.FACILITIES}_${stateId}`, refresh) as IValue[];
	public static setFacilitiesByStateId = (stateId: string, facilities: IValue[]) => QCCATSessionStorage.setValue(`${StorageItems.FACILITIES}_${stateId}`, facilities);

	public static getTitles = (refresh: boolean = false) => QCCATSessionStorage.getValue(StorageItems.TITLES, refresh) as IValue[];
	public static setTitles = (titles: IValue[]) => QCCATSessionStorage.setValue(StorageItems.TITLES, titles);

	public static getLastAjaxMonitorPushUpTime = (refresh: boolean = false) => QCCATSessionStorage.getValue(StorageItems.AJAX_MONITOR_LAST_PUSH_UP_TIME, refresh);
	public static setLastAjaxMonitorPushUpTime = (lastTime: any) => QCCATSessionStorage.setValue(StorageItems.AJAX_MONITOR_LAST_PUSH_UP_TIME, lastTime);

	public static getStates = (refresh: boolean = false) => QCCATSessionStorage.getValue(StorageItems.STATES, refresh) as IState[];
	public static setStates = (states: IState[]) => QCCATSessionStorage.setValue(StorageItems.STATES, states);

	public static getPositions = (refresh: boolean = false) => QCCATSessionStorage.getValue(StorageItems.POSITIONS, refresh) as IValue[];
	public static setPositions = (positions: IValue[]) => QCCATSessionStorage.setValue(StorageItems.POSITIONS, positions);

	public static getContactDetails = (refresh: boolean = false) => QCCATSessionStorage.getValue(StorageItems.CONTACTDETAILS, refresh) as any;
	public static setContactDetails = (contactDetails: any) => QCCATSessionStorage.setValue(StorageItems.CONTACTDETAILS, contactDetails) as any;

	public static getQOOLUserAssociatedData = (refresh: boolean = false) => QCCATSessionStorage.getValue(StorageItems.QOOLUSERASSOCIATEDDATA, refresh) as any;
	public static setQOOLUserAssociatedData = (qoolUserAssociatedData: any) => QCCATSessionStorage.setValue(StorageItems.QOOLUSERASSOCIATEDDATA, qoolUserAssociatedData);

	public static clearLastTermsAcceptanceDate = () => QCCATSessionStorage.setLastTermsAcceptanceDate(undefined);
	public static setLastTermsAcceptanceDate = (value: any) => QCCATSessionStorage.setValue(acceptTermsKey, value);
    public static getLastTermsAcceptanceDate = () => QCCATSessionStorage.getValue(acceptTermsKey);
}